import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/**
 * MapViewPreserver Component
 * 
 * Preserves the map's view state (zoom, center) across component re-renders.
 * Always uses the previous zoom level and center when component re-renders.
 */
const MapViewPreserver = () => {
  const map = useMap();
  
  // Store the current view state in a static variable to persist it
  // even when the component re-renders
  if (!MapViewPreserver.viewState) {
    MapViewPreserver.viewState = {
      zoom: map.getZoom(),
      center: map.getCenter()
    };
  }
  
  // When the component mounts (or remounts after re-render),
  // restore the view state
  useEffect(() => {
    const { zoom, center } = MapViewPreserver.viewState;
    map.setView(center, zoom, { animate: false });
    
    // Update view state when user interacts with the map
    const updateViewState = () => {
      MapViewPreserver.viewState = {
        zoom: map.getZoom(),
        center: map.getCenter()
      };
    };
    
    map.on('zoom', updateViewState);
    map.on('move', updateViewState);
    
    return () => {
      map.off('zoom', updateViewState);
      map.off('move', updateViewState);
    };
  }, [map]);
  
  return null;
};

// Initialize static property
MapViewPreserver.viewState = null;

export default MapViewPreserver; 